<template>
  <div class="atArea" v-show="isShowBox || onlyShowAtinput">
    <div class="atInputWrapper" :class="onlyShowAtinput?'atTextarea':'atReplyarea'">
      <div class="input_box">
        <div :class="['atInput','atInput' + atInputUniqueId,{'red_border': isShowTips}]" ref="refAtInput"
             contenteditable="true" oncontrolselect="return false" spellcheck="false"
             @keydown="keydownAtInput($event)" @keyup="keyupAtInput($event)" @click="click">
          <p><br></p>
        </div>
        <div class="input_control" :style="{'color':(maxInputNum - atInputTextNum) < 0 ? 'red':''}">
          {{atInputTextNum }}/{{maxInputNum}}
        </div>
        <div v-if="!atInputTextNum" class="placeholder" @click.stop="() => refAtInput.focus()">{{ atPlaceholder }}
        </div>
        <div class="required_tips" v-show="isShowTips">{{ updateTipText }}</div>
      </div>
    </div>

    <div class="button_area" v-if="!onlyShowAtinput">
      <div class="cancle" @click="initAtInputArea">{{ getLangMsg("commRecord_cancel") }}</div>
      <div class="submit" @click="submitReply">{{ getLangMsg("commRecord_release") }}</div>
    </div>
    <div :class="'atPopover '+'atPop'+atInputUniqueId" v-show="state.visible" @click.stop="">
      <div class="atSelect_area" @keydown="keydownPeopleList($event)">
        <div class="people_search">
          <el-input
              ref="refSearchInput"
              size="mini"
              :placeholder="getLangMsg('commRecord_key005')"
              prefix-icon="kdfont kdfont-f"
              @input="searchPeople"
              v-model="searchText">
          </el-input>
        </div>
        <div class="people_list" @click.stop="">
          <div class="noData_tip" v-show="!loading_list && peopleAtList && peopleAtList.length === 0">{{ getLangMsg("commRecord_key006") }}</div>
          <div v-for="(item,index) in peopleAtList" :key="item.id" class="people_at_item"
               @mouseenter.stop.prevent="peopleCurIndex=index"
               :class="{'isSelect':index === peopleCurIndex}" @click="select(item)">
            <span>{{ item.name }}（{{ item.number }}）</span>
            <span>{{ item.email }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    onlyShowAtinput: Boolean,
    atInputUniqueId: String,
    cusParam_release: Number,
    cusParam_searchPeoples: Array
  },
  computed: {
    updateTipText() {
      let tipText = '';
      if (this.atInputTextNum === 0) {
        tipText = this.getLangMsg("commRecord_key007")
      }
      if (this.atInputTextNum > this.maxInputNum) {
        tipText = this.getLangMsg("commRecord_key008",{'num':this.maxInputNum})
      }
      return tipText;
    },
    isShowTips() {
      if (this.isTriggerRequiredTip && this.atInputTextNum === 0) {
        return true
      }
      if (this.isTriggerMoreTextNumTip && this.atInputTextNum > this.maxInputNum) {
        return true
      }
      return false;
    },
  },
  watch: {
    cusParam_release: function (val) {
      this.submitTheme()
    },
    cusParam_searchPeoples: function (val) {
      this.peopleAtList = val;
      this.loading_list = false;
    }
  },
  data() {
    return {
      className: '__at_img',
      state: {
        visible: false, // 是否显示选择人员弹窗
        selection: null,
        range: null,
        focusOffset: 0, // 缓存光标所在位置
        focusNode: {}, // 缓存光标所在节点
      },
      refAtInput: {},
      atPlaceholder: this.getLangMsg("commRecord_key009"),
      searchText: "",
      peopleAtList: [],
      replyParams: {},
      peopleCurIndex: 0,
      atInputTextNum: 0,
      maxInputNum: 500,
      isShowBox: false,
      loading_list: true,
      isTriggerMoreTextNumTip: false,
      isTriggerRequiredTip: false,
      isReleaseIng: false,
      isSelectedIng:false,
      iTime: null
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    /**
     * 初始化
     */
    init() {
      //赋值At输入框元素节点
      this.refAtInput = this.$refs.refAtInput;
      //初始化atInput输入框
      this.initAtInputArea();
      this.refAtInput.focus();
      this.refAtInput.addEventListener('paste', this.pasteText, false)
      //注册点击外部atInput框关闭的事件
      let this_ = this;
      $(document).click(() => {
        this_.initPeopleListPop();
        this_.state.visible = false;
      })
    },
    
    /**
     * 监听@输入框事件
     * @param e 入参
     */
    keydownAtInput(e) {
      // keydown触发事件
      if(this.isSelectedIng){return}
      if (this.judgeKeyDownAt(e)) {
        this.open()
        this.calcAtInputTextLength()
      }
      if (e.keyCode === 8 || e.code === 'Backspace') {
        this.listenBackspaceToSetDefaultTag()
        this.calcAtInputTextLength()
      }
    },

    /**
     * 监听@输入框事件
     * @param e 入参
     */
    keyupAtInput(e) {
      if(this.isSelectedIng){return}
      if (e.keyCode === 8 || e.code === 'Backspace') {
        this.listenBackspaceToSetDefaultTag()
      }
      this.calcAtInputTextLength()
    },

    /**
     * 监听回车键识别是否@输入框清空，清空则默认填入初始化标签结构
     */
    listenBackspaceToSetDefaultTag() {
      if (this.refAtInput.innerHTML === "") {
        this.refAtInput.innerHTML = "<p><br></p>"
      }
      if (this.getBrowserName() === 'IE' && this.refAtInput.innerHTML === '<br>') {
        this.refAtInput.innerHTML = "<p><br></p>"
      }
      if (this.getBrowserName() === 'Firefox' && this.refAtInput.innerHTML === '<br>') {
        this.refAtInput.innerHTML = "<p><br></p>"
      }
    },

    /**
     * 计算@输入框文本长度
     */
    calcAtInputTextLength() {
      let atInputTextString = this.transAtInputHtmlToText();
      this.atInputTextNum = Math.max(atInputTextString.length - 1, 0);
      if (this.atInputTextNum <= this.maxInputNum) {
        this.isTriggerMoreTextNumTip = false
      }
      if (this.atInputTextNum > 0) {
        this.isTriggerRequiredTip = true
      }
    },

    /**
     * 将@输入框内容转为text文本格式
     * @returns {string} 转后的text
     */
    transAtInputHtmlToText() {
      let atInputHtmlString = this.refAtInput.innerHTML;
      let atImgList = $('.atInput' + this.atInputUniqueId + ' .__at_img');
      console.log(atImgList)
      let atInputTextString = atInputHtmlString.replaceAll('<p>', '').replaceAll('</p>', ' ').replaceAll('<br>', '').replaceAll('</br>', '').replaceAll('&nbsp;',' ')
      for (let atImgItem = 0, len = atImgList.length; atImgItem < len; atImgItem++) {
        let name = $(atImgList[atImgItem]).attr('data-name');
        atInputTextString = atInputTextString.replace(/<img[^>]*>/, `@${name} `)
      }
      console.log(atInputTextString)
      return atInputTextString;
    },

    /**
     * 将@输入框内容进行格式化，发送提交的时候用
     * @returns {*} 转化后的版本
     */
    transAtInputContentToSendHTML() {
      let atInputHtmlString = this.refAtInput.innerHTML;
      let atInputSendHtmlString = atInputHtmlString;
      let atImgList = $('.atInput' + this.atInputUniqueId + ' .__at_img');
      atInputSendHtmlString = atInputSendHtmlString.replace('<p>', '<span>').replace('</p>', '</span>');
      for (let atImgItem = 0, len = atImgList.length; atImgItem < len; atImgItem++) {
        let id = $(atImgList[atImgItem]).attr('data-id');
        let name = $(atImgList[atImgItem]).attr('data-name');
        let replaceHtml = `<span class="__at_span" data-id="${id}">@${name}</span>`
        atInputSendHtmlString = atInputSendHtmlString.replace(/<img[^>]*>/, replaceHtml)
      }
      console.log(atInputSendHtmlString)
      return atInputSendHtmlString;
    },

    /**
     * 兼容判断按下的键是否为@键
     * @param e 入参
     * @returns {boolean} 是否
     */
    judgeKeyDownAt(e) {
      if (e.key === '@' && e.keyCode === 50 && e.shiftKey) {
        return true
      }
      if (this.getBrowserName() === 'Firefox' && e.code === 'Digit2' && e.shiftKey) {
        return true
      }
      if (this.getBrowserName() === 'Chrome' && e.keyCode === 229 && e.code === 'Digit2' && e.shiftKey) {
        return true
      }
      if (this.getBrowserName() === 'IE' && e.keyCode === 229 && e.key === '@' && e.shiftKey) {
        return true
      }
      return false;
    },

    /**
     * 打开选人列表浮框
     */
    open() {
      let selection = this.state.selection = window.getSelection();
      let range = this.state.range = selection.getRangeAt(0);
      // 缓存光标所在节点
      this.state.focusNode = selection.focusNode
      // 缓存光标所在节点位置
      this.state.focusOffset = selection.focusOffset
      //清空选择框人列表数据
      this.initPeopleListPop();
      //检索人员列默认选中第一条
      this.peopleCurIndex = 0;
      setTimeout(() => {
        // 设置弹窗位置
        let pos = this.getCursorPos();
        let atListBoxEl = $('.atPop' + this.atInputUniqueId)
        atListBoxEl.css({'left': pos.left, 'bottom': pos.bottom})
        // 显示选择框
        this.state.visible = true;
        // 输入框失去焦点
        this.refAtInput.blur();
        //统计at输入框字数
        this.calcAtInputTextLength();
      }, 100)
      // 兼容ie 延迟聚焦
      setTimeout(()=>{
        //搜索框获取焦点
        this.$refs.refSearchInput.focus();
      },200)
    },

    /**
     * 获取当前光标的位置
     * @returns {{top: number, left: number}} 位置信息
     */
    getCursorPos() {
      let selection = window.getSelection();
      let range = selection.getRangeAt(0);
      // 光标所在位置
      let pos = range.getBoundingClientRect()
      let clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      console.log(pos, pos.x, pos.y, pos.top, pos.left,pos.right,pos.bottom)
      return {left: pos.left, top: pos.top,bottom: clientHeight - pos.top}
    },

    /**
     * 选中人员，并写入输入框中
     * @param item 人员对象
     */
    select(item) {
      this.isSelectedIng = true;
      if (this.getBrowserName() === 'IE') {
        this.selectIE(this.creatAtImgElement(item))
      } else {
        this.selectNotIE(this.creatAtImgElement(item))
      }
      this.isSelectedIng = false;
      this.calcAtInputTextLength();
    },

    /**
     * 兼容非IE
     * @param element 生成的人员标签
     */
    selectNotIE(element) {
      const selection = window.getSelection()
      const range = selection.getRangeAt(0)
      // 选中输入的 @ 符
      range.setStart(this.state.focusNode, this.state.focusOffset)
      range.setEnd(this.state.focusNode, this.state.focusOffset + 1)
      // 删除输入的 @ 符
      range.deleteContents()
      // 选中元素节点
      range.insertNode(element)
      this.initPeopleListPop();
      //更新输入框已录数
      this.atInputTextNum = this.refAtInput.innerText.length;
      // 光标移动到末尾
      range.collapse()
      // 聚焦输入框
      this.refAtInput.focus()
      // 关闭选择框
      this.state.visible = false
    },

    /**
     * 兼容IE
     * @param element 生成的人员标签
     */
    selectIE(element) {
      const selection = this.state.selection
      const range = this.state.range
      // 选中输入的 @ 符
      range.setStart(this.state.focusNode, this.state.focusOffset)
      range.setEnd(this.state.focusNode, this.state.focusOffset + 1)
      // 删除输入的 @ 符
      range.deleteContents()
      let frag = document.createDocumentFragment(), atNode
      atNode = frag.appendChild(element)
      // 选中元素节点
      range.insertNode(frag)
      this.initPeopleListPop();
      //更新输入框已录数
      this.atInputTextNum = this.refAtInput.innerText.length;
      this.refAtInput.focus()
      // 光标移动到末尾
      let range1 = document.body.createTextRange();
      range1.moveToElementText(document.getElementsByClassName('atInput' + this.atInputUniqueId)[0]);
      range1.collapse(false);
      range1.select();
      this.state.visible = false
      // // 标记为常规修改
      // lock()
    },

    /**
     * 创建人员标签
     * @param item 人员对象
     * @returns {HTMLImageElement} 人员标签
     */
    creatAtImgElement(item) {
      const element = document.createElement('img');
      element.className = this.className;
      element.dataset.id = item.id;
      element.dataset.name = item.name;
      let nameLogoText = this.cutString(item.name,20);
      element.src = this.drawNameLogo(`@${nameLogoText}`);
      element.title = item.name;
      return element;
    },

    /**
     * 根据文字生成cavns图片
     * @param text 文本
     * @returns {string} 图片二进制数据
     */
    drawNameLogo(text) {
      // 创建画布
      let canvas = document.createElement('canvas');
      // 绘制文字环境
      let context = canvas.getContext('2d');
      // 设置字体
      context.font = '12px Microsoft YaHei';
      // 获取字体宽度
      let width = context.measureText(text).width;
      width = width + 4;
      // 画布宽度
      canvas.width = width;
      // 画布高度
      canvas.height = 16;
      // 填充白色
      context.fillStyle = 'transparent';
      // 绘制文字之前填充白色
      context.fillRect(0, 0, canvas.width, canvas.height);
      // 设置水平对齐方式
      context.textAlign = 'left';
      // 设置垂直对齐方式
      context.textBaseline = 'middle';
      // 设置字体颜色
      context.fillStyle = '#5582F3';
      // 绘制文字（参数：要写的字，x坐标，y坐标）
      context.font = '12px Microsoft YaHei';
      if (this.getBrowserName() === 'IE') {
        context.fillText(text, 0, 7);
      } else {
        context.fillText(text, 0, 9);
      }
      // 生成图片信息
      let dataUrl = canvas.toDataURL('image/png');
      return dataUrl;
    },

    /**
     * 处理@输入框的粘贴事件
     * @param event
     */
    pasteText(event) {
      // 阻止默认的复制事件
      event.preventDefault ? event.preventDefault() : event.returnValue = false
      let pureText;
      let clp = (event.originalEvent || event).clipboardData;
      // 兼容前者针对于opera ie等浏览器，后者针对chrome firefox
      pureText = !clp ? window.clipboardData.getData("text") || "" : clp.getData('text/plain') || "";
      if (pureText === '') {
        return
      }
      if (window.getSelection) {
        // 兼容chorme hotfire ie11 10 9 safari
        // 插入文本节点
        window.getSelection().getRangeAt(0).insertNode(document.createTextNode(pureText))
        // 将焦点移动到复制文本结尾
        window.getSelection().getRangeAt(0).collapse(false);
      } else {
        // 兼容ie10 9 8 7 6 5
        document.selection.createRange().pasteHTML(pureText);
      }
    },

    /**
     * 点击@输入框事件
     * @param target 入参
     */
    click(target) {
      if (target.className === this.className) {
        const selection = window.getSelection()
        const range = selection.getRangeAt(0)
        range.selectNode(target)
      }
    },

    /**
     * 远程搜索人员
     */
    searchPeople() {
      let _this = this;
      clearTimeout(this.iTime);
      this.iTime = setTimeout(function () {
        if (_this.searchText == null || _this.searchText.length < 2) {
          _this.peopleAtList = [];
          return;
        }
        _this.loading_list = true;
        _this.invoke('form_searchPeople', _this.searchText)
      }, 800);
    },

    /**
     * 初始化@输入框
     */
    initAtInputArea() {
      this.refAtInput.innerHTML = "<p><br></p>";
      this.atInputTextNum = 0;
      this.isTriggerRequiredTip = false;
      this.isTriggerMoreTextNumTip = false;
      this.isReleaseIng = false
      this.isShowBox = false;
    },

    /**
     * 初始化人员列表浮框
     */
    initPeopleListPop() {
      //清空选择框数据
      this.peopleAtList = [];
      this.searchText = '';
    },

    /**
     * 监听人员列表浮框键盘事件
     * @param e
     */
    keydownPeopleList(e) {
      let el_list = $(".atPop" + this.atInputUniqueId + " .people_list");
      switch (e.keyCode) {
        case 38: //上
          this.peopleCurIndex > 0 ? this.peopleCurIndex-- : (this.peopleCurIndex = 0);
          el_list.scrollTop(el_list[0].scrollTop - 40)
          e.preventDefault ? e.preventDefault() : e.returnValue = false
          e.stopPropagation ? e.stopPropagation() : e.cancleBubble = true
          break
        case 40: //下
          this.peopleCurIndex < (this.peopleAtList.length - 1) ? this.peopleCurIndex++ : (this.peopleCurIndex = this.peopleAtList.length - 1);
          el_list.scrollTop(el_list[0].scrollTop + 40)
          e.preventDefault ? e.preventDefault() : e.returnValue = false
          e.stopPropagation ? e.stopPropagation() : e.cancleBubble = true
          break
        case 13: //enter
          if (this.peopleAtList.length > 0) {
            this.select(this.peopleAtList[this.peopleCurIndex])
          }
          e.preventDefault ? e.preventDefault() : e.returnValue = false
          e.stopPropagation ? e.stopPropagation() : e.cancleBubble = true
          break
        default:
          break;
      }
    },

    /**
     * 获取@输入框被@人员列表
     * @returns {[]}
     */
    getAtPeopleList() {
      let atPeopleIds = [];
      let atImgList = $('.atInput' + this.atInputUniqueId + ' .__at_img');
      for (let atImgItem = 0, len = atImgList.length; atImgItem < len; atImgItem++) {
        atPeopleIds.push($(atImgList[atImgItem]).attr('data-id'));
      }
      return atPeopleIds
    },

    /**
     * 校验@输入框输入是否合规
     * @returns {boolean} 是否
     */
    checkAtInput() {
      this.isTriggerRequiredTip = true;
      this.isTriggerMoreTextNumTip = true;
      return !this.isShowTips;
    },

    /**
     * 发布回复
     */
    submitReply() {
      if (this.isReleaseIng) {
        return;
      }
      this.replyParams.rcvcontent = this.transAtInputContentToSendHTML();
      this.replyParams.rcvcontentText = this.transAtInputHtmlToText();
      this.replyParams.atPeoples = this.getAtPeopleList();
      if (!this.checkAtInput()) {
        return;
      }
      console.log(this.replyParams)
      this.invoke("form_submitReplyData", this.replyParams);
      this.isReleaseIng = true;
    },

    /**
     * 发布主题
     */
    submitTheme() {
      let params = {};
      params.content = this.transAtInputContentToSendHTML();
      params.contentText = this.transAtInputHtmlToText();
      params.atPeopleIds = this.getAtPeopleList();
      params.atInputChecked = this.checkAtInput();
      this.invoke("form_submitCommentData", params);
    },

    /**
     * 打开回复的@输入框
     * @param level 回复层级（一级二级）
     * @param recItem 主题数据对象
     * @param rcvItem 主题回复数据对象
     * @param uniqueId 沟通记录唯一标识
     */
    openAtInputArea(level, recItem, rcvItem, uniqueId) {
      this.replyParams = {};
      let replyPeopleName = "";
      if (level === "one") {
        replyPeopleName = recItem.createUserName;
        this.replyParams.commrecid = recItem.commrecId
        this.replyParams.parentid = null;
        this.replyParams.repliedcreatorid = recItem.createUserId
      } else if (level === "two") {
        replyPeopleName = rcvItem.createUserName;
        this.replyParams.commrecid = recItem.commrecId
        this.replyParams.parentid = rcvItem.commrcvId;
        this.replyParams.repliedcreatorid = rcvItem.createUserId
      }
      this.atPlaceholder = this.getLangMsg("commRecord_releasePeople",{'name':this.cutString(replyPeopleName,20)})
      this.isShowBox = true;
      this.$nextTick(() => {
        //光标聚焦
        this.refAtInput.focus();
        //回复框定位到视图底部
        let el_comm_record = $(".comm_record" + uniqueId);
        let el_atInput = $(".comm_record" + uniqueId + ' .atInput' + this.atInputUniqueId)
        let el_comm_record_list = $(".comm_record" + uniqueId + " .record_list");
        let scrollHeight = el_comm_record[0].scrollHeight;
        let scrollListTop = el_comm_record_list.offset().top;
        let curTop = el_atInput.offset().top;
        let scrollAreaHeight = el_comm_record.height();
        let atInputAreaHeight = $(".comm_record" + uniqueId + " .atArea").height()
        let scrollNum = (scrollHeight - scrollAreaHeight) - (scrollHeight - (curTop - scrollListTop)) + atInputAreaHeight;
        // el_comm_record.scrollTop(scrollNum);
        el_comm_record.animate({scrollTop: scrollNum + 'px'}, 200);
      })
    }

  }
}
</script>
<style lang="less">
.atArea {
  .atInputWrapper {
    position: relative;
  }

  .atTextarea {
    .input_box {
      position: relative;
      margin-bottom: 16px;

      .atInput {
        outline: none;
        font-size: 12px;
        height: 80px;
        overflow: auto;
        padding: 8px 6px 15px;
        line-height: 16px;
        border-radius: 2px;
        border: 1px solid #E5E5E5;
        background: #FAFAFA;
        box-sizing: border-box;

        .__at_img {
          vertical-align: bottom;
        }

        &:hover {
          border-color: #5582F3;
        }

        &:focus {
          border-color: #5582F3;
        }
      }

      .red_border {
        border-color: var(--error-color) !important;
      }

      .placeholder {
        font-size: 12px;
        color: #999999;
        line-height: 16px;
        top: 8px;
        left: 8px;
        cursor: text;
        user-select: none;
        position: absolute;
      }

      .input_control {
        position: absolute;
        right: 6px;
        bottom: -15px;
      }

      .required_tips {
        color: var(--error-color);
        height: 0;
        font-size: 12px;
      }
    }
  }

  .atReplyarea {
    .input_box {
      position: relative;
      margin: 12px 0 16px;

      .atInput {
        outline: none;
        font-size: 12px;
        height: 50px;
        overflow: auto;
        padding: 8px 6px 15px;
        line-height: 16px;
        border-radius: 2px;
        border: 1px solid #E5E5E5;
        background: #FFFFFF;
        box-sizing: border-box;

        .__at_img {
          vertical-align: bottom;
        }

        &:hover {
          border-color: #5582F3;
        }

        &:focus {
          border-color: #5582F3;
        }
      }

      .red_border {
        border-color: var(--error-color) !important;
      }

      .placeholder {
        font-size: 12px;
        color: #999999;
        line-height: 16px;
        top: 8px;
        left: 8px;
        cursor: text;
        user-select: none;
        position: absolute;
      }

      .input_control {
        position: absolute;
        right: 6px;
        bottom: -15px;
        color: #999;
      }

      .required_tips {
        color: var(--error-color);
        height: 0;
        font-size: 12px;
      }
    }

  }

  .button_area {
    display: flex;
    font-size: 12px;
    justify-content: flex-end;
    padding-top: 8px;

    .cancle {
      cursor: pointer;
      width: 80px;
      height: 28px;
      text-align: center;
      background: #FFFFFF;
      border-radius: 2px;
      border: 1px solid #D9D9D9;
      line-height: 28px;
      color: #666666;
    }

    .submit {
      cursor: pointer;
      width: 72px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      background: #5582F3;
      border-radius: 2px;
      margin-left: 8px;
      color: #FFFFFF;
      position: relative;

      &:before {
        content: "";
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        position: absolute;
        background-color: hsla(0, 0%, 100%, .35);
        display: none;
      }

      &:hover:before {
        display: block;
      }
    }
  }

  .atPopover {
    position: fixed;
    padding: 0 !important;
    border: 0 !important;
    -webkit-box-shadow: 0 1px 8px 0 rgba(0, 0, 0, .2) !important;
    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, .2) !important;
    background-color: #fff;
    width: 200px;
    -webkit-animation: q-hasJSd 1s steps(1) 0s 1 normal none !important;
    animation: q-hasJSd 1s steps(1) 0s 1 normal none !important;
    -webkit-transform-origin: 50% 0 !important;
    -ms-transform-origin: 50% 0 !important;
    transform-origin: 50% 0 !important;
    z-index: 1000;

    .atSelect_area {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      border-radius: 2px;
    }

    .people_search {
      padding: 5px 0;
      border-bottom: 1px solid #ccc;

      .el-input {
        display: flex;

        input {
          flex-grow: 1;
          width: 100px;
          border-radius: 0;
          border: 0;

          &:hover {
            border-color: #5582F3;
          }

          &:hover + .el-input__prefix > .el-input__icon {
            color: #5582F3;
          }

          &:focus {
            border-color: #5582F3;
          }

          &:focus + .el-input__prefix > .el-input__icon {
            color: #5582F3;
          }
        }
      }
    }

    .people_list {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      max-height: 161px;
      overflow-y: auto;

      .noData_tip {
        padding: 10px 20px;
        font-size: 12px;
        color: #999999;
      }

      .people_at_item {
        height: 40px;
        font-size: 12px;
        color: #666;
        cursor: pointer;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: center;
        padding: 0 20px;

        &:hover {
          background-color: #f5f5f5;
        }

        span {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          word-break: break-all;
        }
      }

      .isSelect {
        background-color: #f5f5f5;
      }
    }

  }
}


</style>


